import { render, staticRenderFns } from "./VerdictTable.vue?vue&type=template&id=421c5c4e&scoped=true"
import script from "./VerdictTable.vue?vue&type=script&lang=js"
export * from "./VerdictTable.vue?vue&type=script&lang=js"
import style0 from "./VerdictTable.vue?vue&type=style&index=0&id=421c5c4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c5c4e",
  null
  
)

export default component.exports